export default __webpack_public_path__ + "static/media/send.d848d89a.svg";